import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { Pagination } from '@/common/types';
import { API_URL, ICarrierDto } from '@/dtos';

export const GET_CARRIERS = 'GET_CARRIERS';


export interface Carrier {
  id: string;
  name: string;
  externalId: string;
}

export const formatCarrier = (carrier: ICarrierDto): Carrier => ({
  id: toString(carrier.id),
  name: carrier.name || '',
  externalId: carrier.external_id || '',
});

const useGetCarriersQuery = (searchValue?: string) => {
  const { isLoading, data } = useQuery([GET_CARRIERS, searchValue], () =>
    api.get<Pagination<ICarrierDto>>(API_URL.CARRIERS, {
      params: {
        ...(searchValue
          ? {
              search_value: searchValue,
            }
          : {}),
      },
    })
  );

  return {
    carriers: (data?.data?.content || []).map((carrier) => formatCarrier(carrier)) as Carrier[],
    isLoading,
  };
};

export default useGetCarriersQuery;
